var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spinarrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE4B\\u200D\\u2642\\uFE0F-Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_Accounts-Pending",
    transform: "translate(-380.000000, -413.000000)",
    fill: "#0061D9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pending-Bet-Copy",
    transform: "translate(370.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spinarrow",
    transform: "translate(10.000018, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0173021903,3.74930461 L1.32193335,1.5421189 C1.37108178,1.45916331 1.49370978,1.45916331 1.54286555,1.5421189 L2.84749671,3.74882738 C2.89664514,3.83178296 2.8350905,3.93571039 2.73727003,3.93571039 L2.18756589,3.93571039 C2.09738021,3.93571039 2.03439389,4.02519089 2.06827277,4.10674939 C2.51681913,5.1819113 4.11720333,6.00349741 5.96103317,6.00349741 C8.13932744,6.00349741 9.98022553,4.8570255 9.98022553,3.49995228 C9.98022553,2.14605263 8.14836702,1.00153736 5.97679136,0.996407145 C5.71387397,0.99594113 5.48053067,0.805789815 5.45381505,0.550400532 C5.4227983,0.252132193 5.66185975,0 5.96104539,0 C8.73961658,0 11,1.57008454 11,3.5 C11,5.42991546 8.73961658,7 5.96104539,7 C3.4448663,7 1.35537979,5.71231593 0.982680385,4.03592855 C0.969796541,3.97813846 0.919216431,3.93619478 0.858618268,3.93619478 L0.127108646,3.93619478 C0.0292881837,3.93572876 -0.0317924972,3.83226735 0.0173583823,3.74931177 L0.0173021903,3.74930461 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinArrow);
export default ForwardRef;